$(document).on("turbolinks:load", () => {

  // メッセージの添付とプレビュー(message_type = normal)
  $('#btn_upload_message_attachments.js_message_type_normal').change(function() {
    var formData;
    formData = new FormData();
    $.each(this.files, function(i, file) {
      return formData.append('attachments[]', file);
    });
    return $.ajax({
      url: '/message_attachments/upload',
      type: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: formData,
      dataType: "JSON",
      contentType: false,
      processData: false,
      success: function(res) {
        return $('#message_attachments_wrap.normal').append(res.content);
      }
    });
  });

  // メッセージの添付とプレビュー(message_type = internal_memo)
  $('#btn_upload_message_attachments.js_message_type_internal_memo').change(function() {
    var formData;
    formData = new FormData();
    $.each(this.files, function(i, file) {
      return formData.append('attachments[]', file);
    });
    return $.ajax({
      url: '/message_attachments/upload',
      type: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      data: formData,
      dataType: "JSON",
      contentType: false,
      processData: false,
      success: function(res) {
        return $('#message_attachments_wrap.internal_memo').append(res.content);
      }
    });
  });
});
